<!--
* @FileDescription: JavaScript 操作辅助
* @Author: Rocky
* @Date: 2020-08-03
* @LastEditors: Rocky
* @LastEditTime: 2020-08-03
-->
<script>
/**
 * 深拷贝对象
 * @param {object} obj 待拷贝对象
 * @returns {object} 拷贝后对象
 */
function copyObj (obj) {
  if (typeof obj !== 'undefined') {
    return JSON.parse(JSON.stringify(obj))
  }
  return obj
}

/**
 * 判断对象是否为空
 * @param {object} obj 对象
 * @returns {boolean} 返回值
 */
function isEmptyObj (obj) {
  for (var key in obj) {
    return false
  }
  return true
}

export default {
  copyObj, isEmptyObj
}
</script>



// WEBPACK FOOTER //
// src/components/toolkits/jsHelper.vue